module.exports = "/_next/static/images/row1-2-2x-7cf2462a5053be8b3b442380a7347626.png";